/** @format */

import autoHeightBlock from './autoHeightBlock';
export default {
  //mixins: [autoHeightBlock],
  data() {
    return {
      contentHeight: 0,
      contentHeightHeader: this.$vuetify.breakpoint.smAndDown ? 144 : 144,
    };
  },
  mounted() {
    window.addEventListener('resize', this.onResize, true);
    this.onResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize, true);
  },
  methods: {
    onResize() {
      let height = window.innerHeight;
      let cc;
      cc = height - this.contentHeightHeader + (this?.title === true ? 0 : 68) - (this.$vuetify.breakpoint.smAndDown ? 20 : 0);
      this.contentHeight = cc;
      if (this.typeShow == 'full') {
        this.$root.windowSize.contentHeight = this.contentHeight;
        this.$root.windowSize.innerHeight = height;
      }
      if (this.typeShow == 'dialog') cc = cc + 50;
      this.contentHeight = cc;
      this.$emit('sendHeight', this.contentHeight);
    },
  },
};
